import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as R from 'ramda';
import { AuthContext } from 'authentication/AuthContext';

// This hook is initially built to work with the useGetAffiliateOptions hook
// that filters the list of user affiliates by a given role. This hook
// will take the list of affiliates provided by useGetAffiliateOptions
// and will redirect to the first valid affiliate if the current
// affiliate is not in the list provided.

/* Example usage:
  useRedirectAffiliateForRole(useGetAffiliateOptions([userRoles.SUPPLIER]));
*/

const useRedirectAffiliateForRole = (
  validAffiliates,
  handleChanged = () => {},
  handleNotChanged = () => {}
) => {
  const { pathname } = useLocation();
  const path = pathname.split('/');
  const { affiliates, currentAffiliate, setCurrentSelectedAffiliate } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      currentAffiliate?.customerIdName &&
      validAffiliates[0]?.customerIdName &&
      affiliates.length > 0
    ) {
      if (
        R.not(
          R.includes(
            currentAffiliate.customerIdName,
            validAffiliates.map(a => a.customerIdName)
          )
        )
      ) {
        const firstValidAffiliate = affiliates.findIndex(
          a =>
            a.customerIdName === validAffiliates[0].customerIdName &&
            a.dataCompanyId === validAffiliates[0].dataCompanyId
        );

        if (firstValidAffiliate) {
          setCurrentSelectedAffiliate(firstValidAffiliate);

          const newUrl = R.compose(
            R.join('/'),
            R.update(3, validAffiliates[0].dataCompanyId),
            R.update(2, validAffiliates[0].customerIdName),
            R.split('/'),
            R.prop('pathname')
          );

          navigate(newUrl(location), { replace: true });
          if (handleChanged) handleChanged();
        }
      }
    } else if (handleNotChanged) handleNotChanged();
  }, [
    validAffiliates,
    currentAffiliate,
    navigate,
    path,
    setCurrentSelectedAffiliate,
    handleChanged,
    handleNotChanged,
    location,
    affiliates,
  ]);
};

export default useRedirectAffiliateForRole;
